import { render, staticRenderFns } from "./Lgx241884626186928128.vue?vue&type=template&id=cf5d87ec&scoped=true&"
import script from "./Lgx241884626186928128.vue?vue&type=script&lang=js&"
export * from "./Lgx241884626186928128.vue?vue&type=script&lang=js&"
import style0 from "./Lgx241884626186928128.vue?vue&type=style&index=0&id=cf5d87ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5d87ec",
  null
  
)

export default component.exports